<template>
  <div>
    <TitleField fieldName="isTrustee" :fieldGroup="FieldGroup.PERSON" />
    <TrusteeSection :data="trusteeInfoBase" documents-hidden />

    <v-row>
      <v-col cols="6">
        <v-text-field
          v-model="$v.trusteeInfo.trusteeStatus.$model"
          :errorMessages="getValidationErrorText($v.trusteeInfo.trusteeStatus)"
          :label="FieldLabel.TRUSTEE_STATUS"
          outlined
        />
      </v-col>
    </v-row>

    <NotaryDocument :v="$v.trusteeInfo.documents.authorityDocument" />

    <slot name="footer" :next="nextHandler"></slot>
  </div>
</template>

<script>
import NotaryDocument from '@/components/services/elements/NotaryDocument';
import cloneDeep from 'clone-deep';
import TitleField from '@/components/elements/statement/FullStatementView/base/TitleField';
import TrusteeSection from '@/components/elements/statement/FullStatementView/elements/Trustee';
import deepmerge from 'deepmerge';
import { FieldGroup } from '@/utils/fullStatementView';
import {
  personTrusteeModel,
  getPersonTrusteeValidation,
} from '@/components/services/EgrnConfirm/Applicant/components/Person/PersonTrustee';
import { getValidationErrorText } from '@/utils/validate';
import { FieldLabel } from '@/constants';

export default {
  name: 'TrusteeInfo',
  components: {
    NotaryDocument,
    TitleField,
    TrusteeSection,
  },
  props: {
    trusteeInfoProp: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    getValidationErrorText,
    FieldLabel,
    FieldGroup,
    trusteeInfo: {
      trusteeStatus: personTrusteeModel.trusteeStatus,
      documents: cloneDeep(personTrusteeModel.documents),
    },
  }),
  computed: {
    trusteeInfoBase() {
      const trusteeInfoFields = Object.keys(this.trusteeInfoProp);

      return trusteeInfoFields.reduce((trusteeInfoBase, field) => {
        if (field !== 'trusteeStatus') {
          trusteeInfoBase[field] = this.trusteeInfoProp[field];
        }

        return trusteeInfoBase;
      }, {});
    },
  },
  validations() {
    const trusteeValidation = getPersonTrusteeValidation(this.trusteeInfo);

    return {
      trusteeInfo: {
        trusteeStatus: trusteeValidation.trusteeStatus,
        documents: trusteeValidation.documents,
      },
    };
  },
  created() {
    this.prefillDraft();
  },
  methods: {
    prefillDraft() {
      this.trusteeInfo = deepmerge(this.trusteeInfo, this.trusteeInfoProp);
    },

    assemblyModel() {
      return deepmerge(this.trusteeInfoProp, this.trusteeInfo);
    },

    async nextHandler() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        await this.$vuetify.goTo('#header-target', { duration: 200 });
        return;
      }

      this.$emit('send', this.assemblyModel());
    },
  },
};
</script>
